/*  eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const INJECTION_KEYS = {
    SNACK:        'snack',
    KEYCLOAK:     'keycloak',
    GLOBALSTATE:  'globalState',
    SESSIONSTATE: 'session'
}
export default INJECTION_KEYS